import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class SubmergedUnitWeightGamaSubCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (SubmergedUnitWeightGamaSubCalculationMethodModel._instance == null) SubmergedUnitWeightGamaSubCalculationMethodModel._instance = new SubmergedUnitWeightGamaSubCalculationMethodModel(authManager);
        return SubmergedUnitWeightGamaSubCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/submerged-unit-weight-gama-sub-calculation-methods', 'geo-sections/submerged-unit-weight-gama-sub-calculation-methods/codelist');

        this.entityName = 'geo-sections.SubmergedUnitWeightGamaSubCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Submerged Unit Weight Gama Sub Calc Method';
        this.setLabel = 'Submerged Unit Weight Gama Sub Calc Methods';

        this.browser = {
            name: 'default-geo-sections-submergedunitweightgamasubcalculationmethod-browser',
            moduleName: 'default-geo-sections-submergedunitweightgamasubcalculationmethod-browser',
            moduleTitle: 'Submerged Unit Weight Gama Sub Calc Methods',
            moduleStateSlotName: 'default-geo-sections-submergedunitweightgamasubcalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-submergedunitweightgamasubcalculationmethod-editor',
            moduleName: 'default-geo-sections-submergedunitweightgamasubcalculationmethod-editor',
            moduleTitle: 'Submerged Unit Weight Gama Sub Calc Method',
            moduleStateSlotName: 'default-geo-sections-submergedunitweightgamasubcalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
